import type { LoginMfaChallenge } from '@kestrel/shared/contracts';

/**
 * The MFA challenge between `POST /api/auth/login` and `/login/mfa`. Kept in memory only (never
 * in the URL or browser storage): a reload loses it and the user signs in again, which is what a
 * 5-minute challenge needs anyway.
 */
let pending: LoginMfaChallenge | undefined;

export function setPendingMfaChallenge(challenge: LoginMfaChallenge | undefined): void {
  pending = challenge;
}

/** The pending challenge, or `undefined` when there is none or it has expired. */
export function pendingMfaChallenge(now: Date = new Date()): LoginMfaChallenge | undefined {
  if (pending === undefined) return undefined;
  if (pending.challengeExpiresAt.getTime() <= now.getTime()) {
    pending = undefined;
    return undefined;
  }
  return pending;
}
